export const highlightTriggerText = (text, triggers) => {
  const escaped = triggers.map((t) =>
    t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/\s+/g, "\\s+"),
  );
  const regex = new RegExp(`(${escaped.join("|")})`, "gi");
  return text.split(regex).map((part) => ({
    text: part,
    highlight: triggers.includes(part),
  }));
};
